import api from "../../apis/siar";

//Querie para obtener los datos de aceleración
const fetchIntensityDataQuery = `query{
    listaInfoAceleracionSismo{
     fecha
      intensidad
      version
      sensores{
        id
        estacion
        valor
      }
      otrosSensores{
        id
        estacion
        valor
      }
    }
  }`;

//Acción para obtener los datos de aceleración
export const fetchIntensityAction = () => async (dispatch, getState) => {
  let queryOrder = fetchIntensityDataQuery;

  const promise = await api.post("/", {
    query: queryOrder,
  });
  dispatch({
    type: "FETCH_INTENSITY",
    payload: promise.data.data.listaInfoAceleracionSismo,
  });
};
